import { useAppStore } from "../../appStore";

/**
 * Actuate staff, for showing technical detail (HTTP status, error codes) that
 * support acts on but customers shouldn't see. Same rule as the
 * Troubleshooter's host field: admin's `internal_user` when it sends one,
 * else superusers (the stricter side).
 */
export const isStaffUser = (permissions: unknown): boolean => {
  const p = permissions as
    | { internal_user?: boolean; super_user?: boolean }
    | null
    | undefined;
  return Boolean(p?.internal_user ?? p?.super_user);
};

export const useIsStaffUser = (): boolean =>
  isStaffUser(useAppStore((s) => s.userPermissions));
